import React, { useEffect, useRef } from "react";
import { Card } from "@shopify/polaris";
import { useQuery } from "@tanstack/react-query";
import CryptoJS from "crypto-js";
import "./index.css";

/**
 * 调用中台Api参数
 */
const DSM_SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
const ACCESS_TYPE = "DSMAPP";

export const RECOMMEND_APPS_QUERY_KEY = ["middleground", "getRecommend"];

const fallbackList = [
  {
    type: 1,
    name: "SEOWILL: AI SEO & AI Blog Post",
    title: "SEOWILL: AI SEO & AI Blog Post",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/QYE9KYmgyfh2F8HRg78YYaFUly6qv0pE3kNr2Rr9.png",
    reviews: "4.8 stars over 1400+",
    recommend:
      "Improve your store's AI and google search rankings\uff1aSEO Issue Checker, Site Speed Up, Al blog,etc.",
    comments: 1400,
    score: 4.8,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://share.seoant.com/app/1169a5543c03dbbSeG",
  },
  {
    type: 1,
    name: "TrustWILL Product Reviews App",
    title: "TrustWILL Product Reviews App",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/9VmJ071VqqC6UhMkCwsnUcq9y0GrFdO54RJYswIZ.png",
    reviews: "4.9 stars over 1490+",
    recommend:
      "Top-rated reviews app \u2014 use AI to uncover insights, collect photo  reviews, engage customers, and bu",
    comments: 1490,
    score: 4.9,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://share.channelwill.com/3JJcMgVS",
  },
  {
    type: 1,
    name: "ParcelWILL Order Tracking",
    title: "CWILL Order Tracking",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/snqk065VAniI6cZRSrkK07qkxQK8BAdxHZ93F4ms.webp",
    reviews: "5 stars over 2850+",
    recommend:
      "Cut 80% WISMO Tickets, Order Tracking Page, One-Click Remove China Factor,  Dropshipping Mode, Upsel",
    comments: 2850,
    score: 5,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://parcelwill.com/?ref=7OLUDqGD&DSM",
  },
  {
    type: 1,
    name: "ParcelWILL Returns & Exchange",
    title: "CWILL Returns & Exchanges",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/XjzBJSrUafRuJ1HxQaGz4eJ4qhVQrsGve2idUpgm.webp",
    reviews: "4.9 stars over 450+",
    recommend:
      "Returns that turn to profit by incentivizing exchanges and providing a self-service returns portal",
    comments: 450,
    score: 4.9,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://returns.parcelwill.com/?ref=mPVIkuHW&DSM",
  },
  {
    type: 1,
    name: "ChatWILL:AI Chatbot &Live Chat",
    title: "CWILL:AI Chatbot &Live Chat",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/5TbklvBsyFvTS8wtMxNaxYJj5aSqoHZkvIkbgAlr.webp",
    reviews: "4.7 stars over 81+",
    recommend: "FREE AI chatbot that turns visitors into buyers.",
    comments: 81,
    score: 4.7,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://share.channelwill.com/cj1EpKJa",
  },
  {
    type: 1,
    name: "TrustWILL Loyalty & Referrals",
    title: "CWILL: Loyalty Program Rewards",
    logo: "https://cw-middleground.oss-us-west-1.aliyuncs.com/CAGqZeqXMxZCCODyut9VYDf57ZKULRizuDSaQSNm.webp",
    reviews: "4.9 stars over 754+",
    recommend:
      "Ultimate loyalty and rewards engine to drive repeat purchases: Points, VIP, Referrals",
    comments: 781,
    score: 4.9,
    is_recommend: 0,
    call_action: "",
    discount: "",
    link: "https://share.channelwill.com/MaYCeVrq",
  },
];

export async function fetchRecommendApps() {
  let timestamp = String(new Date().valueOf());
  timestamp = timestamp.slice(0, 10);
  const DSM_TOKEN = CryptoJS.MD5(DSM_SECRET_KEY + timestamp);
  const setHeaders = new Headers();
  setHeaders.append("ACCESS-TYPE", ACCESS_TYPE);
  setHeaders.append("ACCESS-TOKEN", DSM_TOKEN);
  setHeaders.append("ACCESS-TIME", timestamp);
  setHeaders.append("Content-Type", "application/json");

  const response = await fetch(
    "https://mpapi.channelwill.com/api/v1/middleground/getRecommend",
    {
      method: "GET",
      headers: setHeaders,
    }
  );
  const json = await response.json();
  if (!json.data) {
    return { apps: [], error: true };
  }

  const ResData = json.data;
  let data = [];
  if (ResData.length > 0 && ResData[0]) {
    data = ResData[0].appInfo ? ResData[0].appInfo : [];
  }

  const apps = [];
  for (let i = 0; i < data.length; i++) {
    if (!data[i]) continue;
    apps.push(data[i]);
  }

  return {
    apps,
    error: apps.length === 0,
  };
}

function AppPartners(props) {
  const show = props.show === undefined ? false : props.show;
  const { data, isError, isFetched, isFetching } = useQuery({
    queryKey: RECOMMEND_APPS_QUERY_KEY,
    queryFn: fetchRecommendApps,
    enabled: !!show,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    refetchOnWindowFocus: false,
    // Keep previous successful payload when refetch returns identical data (structuralSharing default)
    placeholderData: (previousData) => previousData,
  });

  // Prefer API list; keep fallback when request failed / empty (same as old behavior)
  const appList =
    data?.apps?.length > 0 ? data.apps : fallbackList;
  const getDataError = isError || (isFetched && !!data?.error);

  // Callback lives in a ref so the parent re-rendering (which recreates props)
  // never re-triggers the effect below.
  const callBackFunRef = useRef(props.callBackFun);
  callBackFunRef.current = props.callBackFun;

  useEffect(() => {
    if (!show || isFetching) return;
    if (!isFetched && !isError) return;
    try {
      if (typeof callBackFunRef.current === "function") {
        callBackFunRef.current({ result: getDataError });
      }
    } catch (error) {}
  }, [show, isFetched, isFetching, isError, getDataError]);

  let AppList = "";
  if (appList.length > 0) {
    AppList = appList.map((item, key) => {
      return (
        <div className="Dropshipman_App_Partners_Item" key={key}>
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <div className="App_Box">
              <div className="Top">
                <img src={item.logo} alt="DropShipMan" />
                <div className="App_Name">
                  <div className="title" title={item.title}>
                    {item.title}
                  </div>

                  <div className="star_box">
                    <span>
                      {item.score.toFixed(1)}
                      {" (" + item.comments + ")"}
                    </span>
                    <img
                      src="/start.png?v=123456"
                      alt="DropShipMan"
                      className="star"
                    />
                    <img
                      src="/start.png?v=123456"
                      alt="DropShipMan"
                      className="star"
                    />
                    <img
                      src="/start.png?v=123456"
                      alt="DropShipMan"
                      className="star"
                    />
                    <img
                      src="/start.png?v=123456"
                      alt="DropShipMan"
                      className="star"
                    />
                    <img
                      src="/start.png?v=123456"
                      alt="DropShipMan"
                      className="star"
                    />
                  </div>
                </div>
              </div>

              <div className="Bottom">
                <span title={item.recommend}>{item.recommend}</span>
              </div>
            </div>
          </a>
        </div>
      );
    });
  }

  const pageContent1 = show && AppList && (
    <Card title="" sectioned>
      <section className="Dropshipman_App_Partners">{AppList}</section>
    </Card>
  );
  const pageContent2 = show && AppList && (
    <section className="Dropshipman_App_Partners">{AppList}</section>
  );

  return <>{props?.round ? pageContent2 : pageContent1}</>;
}

export default AppPartners;
